// @flow

import type {BiePluginType} from '../types';
import {CanvasManager} from '../managers/canvas-manager';
import {fabric} from 'fabric';

export class BieTextPlugin implements BiePluginType {
  cm: CanvasManager;

  currentColor: string;
  objectsCount: number;

  setup() {}

  getActionButtons() {
    return [
      {
        type: 'enter-state',
        title: 'Add text',
        icon: 'fas fa-font',
        slug: 'text',
        component: 'div',
        enter: this.start,
        cancel: this.cancel,
        confirm: this.confirm,
        triggerEvent: this.handleEvent,
        eventButtons: [
          {
            type: 'colorPalette',
          },
        ],
      },
    ];
  }

  handleEvent = (cm: CanvasManager, event: any) => {
    this.currentColor = event.type;
  };

  removeListeners(cm: CanvasManager) {
    cm.canvas.off('mouse:down', this.onMouseDown);

    cm.canvas.selection = true;
    cm.canvas.hoverCursor = 'move';
  }

  cancel = (cm: CanvasManager) => {
    this.removeListeners(cm);
    cm.canvas
      .getObjects()
      .slice(this.objectsCount)
      .map((object) => cm.canvas.remove(object));
    cm.canvas.renderAll();
  };

  confirm = (cm: CanvasManager) => {
    this.removeListeners(cm);
    cm.saveState();
  };

  start = (cm: CanvasManager) => {
    this.objectsCount = cm.canvas.getObjects().length;
    this.currentColor = 'red';
    this.cm = cm;
    cm.canvas.selection = false;
    cm.canvas.hoverCursor = 'crosshair';

    cm.canvas.on('mouse:down', this.onMouseDown);
  };

  onMouseDown = (event) => {
    if (this.cm.canvas.getActiveObject() != null) {
      return;
    }

    const textbox = new fabric.Textbox('Add text here..', {
      left: event.absolutePointer.x,
      top: event.absolutePointer.y,
      width: 300,
      fontSize: 60,
      fill: this.currentColor,
      fontFamily: 'Arial',
    });
    this.cm.canvas.add(textbox).setActiveObject(textbox);
    this.cm.canvas.renderAll();
  };
}
